module.exports = __webpack_public_path__ + "media/images/icons/twotone/tool-4278f38f55d7f2a3405f45813035a986.svg";